import React, { useState } from "react";
import Card from "../../../components/Card";
import Confirm from "../../../components/Confirm";
import Modal from "../../../components/Modal";
import TemplateModal from "../../NewProduct/TemplateModal";
import { UseApi } from "../../../hooks/use-api";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import { CreateCollection as CreateCollection_ } from "../../../Services/lib/nft";
import ImagesAndCTA from "../../NewProduct/ImagesAndCTA";
import NameAndDescription from "../../NewProduct/NameAndDescription";
import styles from "./CreateCollection.module.sass";
import TemplateSelector from "./template";
import cn from "classnames";
import { useUser } from "../../../context";
import collection from "../../../i11/Collection";
import RichEditor from "../../../components/HTMLeditor/DraftEditor";

const CreateCollection = ({
	initialVal = {
		name: "",
		description: "",
		image: "",
		nftTemplates: [],
	},
	type,
	close,
	noDraft,
}) => {
	const { locale } = useUser();
	const [reqBody, setReqBody] = useState({
		...initialVal,
		nftTemplates: initialVal.nftTemplates.map((e) => e._id),
	});

	const [{ isLoading }, createCollection] = UseApi({
		service: CreateCollection_,
	});

	const [uploading, setUploading] = useState(false);
	const { onOpen, onClose, isOpen } = UseDisclosure();

	const onSubmit = (e) => {
		e.preventDefault();
		if (uploading) {
			ToastEmitter({
				type: "info",
				msg: "Wait till finish the image upload",
			});
		} else {
			onOpen();
		}
	};

	const save = async (isDraft = false) => {
		const tmp = { ...reqBody };
		if (tmp._id) {
			delete tmp["nftTemplates"];
		} else {
			delete tmp["addTemplates"];
			delete tmp["removeTemplates"];
		}
		const tmpImg = tmp.image;
		if (isDraft) {
			tmp.status = "DRAFT";
		} else {
			tmp.status = "SCHEDULE";
		}
		tmp.image = tmpImg.core_image_url;
		tmp.image_list = tmpImg.image_list;

		console.log("save ==>");
		console.log(tmp);
		const res_ = await createCollection(tmp);
		if (res_) {
			ToastEmitter({
				type: "success",
				msg: "Your collecton successfully published",
			});
			setReqBody({
				name: "",
				description: "",
				image: "",
				startDate: "",
				endDate: "",
				nftTemplates: [],
			});
			close();
		}
	};
	const { isOpen: V, onOpen: createO, onClose: createC } = UseDisclosure();
	const setHtml = async (e) => {
		if (reqBody._id) {
			const res = await createCollection({
				_id: reqBody._id,
				drawHtml: e,
			});
			if (res) {
				ToastEmitter({
					type: "success",
					msg: "Html saved successfully",
				});
			}
		}
		setReqBody((p) => {
			return { ...p, drawHtml: e };
		});
	};
	return (
		<Card
			className={styles.card}
			title={
				reqBody._id
					? collection[locale].edit_collection
					: collection[locale].create_collection
			}
			classTitle="title-green"
		>
			<form onSubmit={onSubmit}>
				<NameAndDescription
					setReqBody={setReqBody}
					reqBody={reqBody}
					createO={createO}
				/>
				<ImagesAndCTA
					setUploading={setUploading}
					reqBody={reqBody}
					setReqBody={setReqBody}
				/>
				<TemplateSelector
					initial={reqBody.nftTemplates}
					reqBody={reqBody}
					initialData={initialVal.nftTemplates}
					setReqBody={setReqBody}
				/>
				<div className={styles.foot}>
					{(!reqBody._id || type === "Drafts") && !noDraft && (
						<button
							onClick={() => save(true)}
							type="button"
							className={cn("button-stroke", {
								disabled: isLoading,
							})}
						>
							{collection[locale].save_draft}
						</button>
					)}
					<button type="submit" className="button">
						{reqBody._id && type !== "Drafts"
							? collection[locale].save
							: collection[locale].publish}
					</button>
				</div>
			</form>
			<Modal visible={isOpen} onClose={onClose}>
				<Confirm
					title={collection[locale].publish_confirm}
					onCancel={onClose}
					onConfirm={() => save()}
					isLoading={isLoading}
				>
					{reqBody.nftTemplates.length === 0 && (
						<div className={styles.warings}>
							{collection[locale].empthy}
						</div>
					)}
				</Confirm>
			</Modal>
			<TemplateModal visible={V} onClose={createC}>
				{V && (
					<RichEditor
						data={reqBody.drawHtml}
						setData={setHtml}
						onClose={createC}
					/>
				)}
			</TemplateModal>
		</Card>
	);
};

export default CreateCollection;
